import React from 'react';
import Modal from './Modal';

interface Shortcut {
  keys: string[];
  description: string;
  category: string;
}

const shortcuts: Shortcut[] = [
  { keys: ['⌘', 'K'], description: '開啟全局搜尋', category: '導航' },
  { keys: ['Esc'], description: '關閉彈出窗口和下拉選單', category: '導航' },
  { keys: ['⌘', '⇧', 'N'], description: '新增病患', category: '操作' },
  { keys: ['⌘', '⇧', 'A'], description: '新增預約', category: '操作' },
  { keys: ['?'], description: '顯示鍵盤快捷鍵說明', category: '幫助' },
];

interface KeyboardShortcutsHelpProps {
  isOpen: boolean;
  onClose: () => void;
}

const KeyboardShortcutsHelp: React.FC<KeyboardShortcutsHelpProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const categories = Array.from(new Set(shortcuts.map(s => s.category)));

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="鍵盤快捷鍵"
      description="使用這些快捷鍵提升工作效率"
      size="lg"
    >
      <div className="space-y-6">
          {categories.map((category) => (
            <div key={category}>
              <h3 className="mb-3 text-sm font-semibold text-slate-500 uppercase tracking-wide">
                {category}
              </h3>
              <div className="space-y-2">
                {shortcuts
                  .filter((s) => s.category === category)
                  .map((shortcut, idx) => (
                    <div
                      key={idx}
                      className="flex items-center justify-between rounded-lg border border-slate-200 bg-slate-50 px-4 py-3"
                    >
                      <span className="text-sm text-slate-700">{shortcut.description}</span>
                      <div className="flex gap-1">
                        {shortcut.keys.map((key, keyIdx) => (
                          <kbd
                            key={keyIdx}
                            className="inline-flex min-w-[2rem] items-center justify-center rounded-md border border-slate-300 bg-white px-2 py-1 text-sm font-semibold text-slate-700 shadow-sm"
                          >
                            {key}
                          </kbd>
                        ))}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>

      <div className="mt-6 rounded-lg bg-blue-50 px-4 py-3">
        <p className="text-sm text-blue-800">
          <span className="font-semibold">提示：</span> 按 <kbd className="mx-1 rounded border border-blue-300 bg-white px-2 py-0.5 text-xs font-semibold">?</kbd> 隨時查看此說明
        </p>
      </div>
    </Modal>
  );
};

export default KeyboardShortcutsHelp;
